import { mutate } from "swr";
import { endpointsAssets } from "../actions/endpoints/endpointsAssets";
import { authenticatedAxios } from "../actions/fetcher";

export function dismissIngress(
  projectId: number,
  ingressId: number,
  cancelUploadCallback: () => void,
): Promise<void> {
  return authenticatedAxios
    .request<void>({
      ...endpointsAssets.ingressDismiss(ingressId),
      headers: { "Content-Type": "application/json" },
    })
    .then(() => {
      // Need to remove the upload object from the browser memory as well, since
      // "ingress dismiss" only clears the associated ingress record from the server
      cancelUploadCallback();

      mutate(endpointsAssets.projectIngresses(projectId));
    });
}
